import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { AlertModule } from '../alert/alert.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { ItineraryResumeModule } from '../itinerary-resume/itinerary-resume.module';
import { StepSplitComponent } from './step-split.component';

@NgModule({
  declarations: [StepSplitComponent],
  imports: [ CommonModule, SharedModule, AlertModule, InputSubmitModule, ItineraryResumeModule ],
  exports: [StepSplitComponent]
})
export class SplitModule { }
